export default function VisaApplications({
  redirectToLeadWithCategory,
  stats,
}) {
  return (
    <div className="bg-white rounded-lg p-6 shadow-custom">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        Visa Applications
      </h2>
      {stats?.visaTypes?.length < 1 || !stats?.visaTypes ? (
        <div className="text-gray-600 text-center py-10">
          No Visa Applications Found.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {(stats?.visaTypes || []).map((name) => (
            <div
              key={name}
              className="bg-[#87CA60] rounded-xl p-4 flex flex-col space-y-1 cursor-pointer"
              onClick={() => redirectToLeadWithCategory(name)}
            >
              <span className="text-gray-900 font-medium">
                {name.split(' ')[0]} Visa
              </span>
              <span className="text-2xl font-semibold text-gray-900">
                {stats?.visaTypeCounts?.[name] || 0}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
